export default {"src":"/_next/static/media/back.db560e53.svg","height":25,"width":24};